import moment from 'moment';

export const getRelativeTime = (strNotiTime: Date) => {
  const now = moment().format('YYYY-MM-DD');
  const previous = moment(strNotiTime).format('YYYY-MM-DD');
  if (now === previous) {
    return moment(strNotiTime, 'YYYY-MM-DDTHH:mm:ssZZ').calendar();
  } else {
    return moment(strNotiTime, 'YYYY-MM-DDTHH:mm:ssZZ').format('LLLL');
  }
};
